import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
import Aes from '@/utils/Aes'

const notTipList = ['checkThreeFoldOrder']

const service = axios.create({
    // eslint-disable-next-line no-undef
    baseURL: u_config.api,
    timeout: 500000
})
service.interceptors.request.use(
    config => {
        if (store.getters.token) config.headers['Authorization'] = store.getters.token;
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
service.interceptors.response.use(
    response => {
        const res = response.data
        let url = response.config.url.split('/');
        let api = url[url.length - 1];

        if (!res.success) {
            // eslint-disable-next-line no-prototype-builtins
            if (res.hasOwnProperty('meta') && res.meta.code == 200) {
                return res;
            } else {
                let message = res.error.messages;
                try {
                    message = Aes.decrypt(message)
                } catch (error) { console.log(error); }
                if (res.error.code == 11) {
                    Message({
                        message: message + ', 即将跳转到登录页！',
                        type: 'error',
                        duration: 3000
                    })
                    setTimeout(() => {
                        store.commit('logout').then(() => {
                            location.reload()
                        })
                    }, 3000);
                } else if (!notTipList.includes(api)) {
                    Message({
                        message: message || 'Error',
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
                store.commit("hideLoading");
                return Promise.reject(message)
            }
        } else {
            if (res.result) {
                if (!["generateTempQRCode", "completions" ].includes(api) ) {
                    res.result = /^\w+/.test(res.result) ? Aes.decrypt(res.result) : res.result;
                }
            } else {
                if (res.encrypt) res.result = Aes.decrypt(res.encrypt)
            }
            // eslint-disable-next-line no-undef
            if (u_config.debug) {
                console.log(api, JSON.parse(JSON.stringify(res)));
            }
            return res;
        }
    },
    error => {
        Message({
            message: error || 'Error',
            type: 'error',
            duration: 5 * 1000
        })
        store.commit("hideLoading");
        return Promise.reject(error)
    }
)

export default service